import { useFormContext, useWatch } from "react-hook-form";
import useIntakeFormStore from "../../../store/IntakeForm.store";

import Disclosures from "../../Disclosures";
const IntakeFormDisclosure = () => {
  const { control } = useFormContext();
  const categoryValue = useWatch({
    control,
    name: "selectCategory",
  });
  const strategy = useWatch({
    control,
    name: "selectStrategy",
  });

  const [formOptions] = useIntakeFormStore((state) => [state.data.formOptions]);
  const assetClass = formOptions.strategyDetails.find(
    (strat) => strat.sector === categoryValue && strat.strategyCode === strategy
  )?.assetClass;

  const marketingCommunication = "Marketing Communication";

  const fixedIncomeDisclosureArgs = {
    className: "disclosures--proposal",
    bodyContent: [
      {
        heading: marketingCommunication,
        content: (
          <ul>
            <li>Not Insured by the FDIC or Any Federal Government Agency</li>
            <li>
              Not a Deposit or Other Obligation of, or Guaranteed by, the Bank
              or Any Bank Affiliate
            </li>
            <li>
              Subject to Investments Risks, Including Possible Loss of the
              Principal Amount Invested
            </li>
            <li>For Investment Professional Use Only</li>
          </ul>
        ),
      },
      {
        heading: "",
        content: (
          <>
            <p>
              Investments in fixed-income securities are subject to market,
              interest rate, credit and other risks. Bond prices fluctuate
              inversely to changes in interest rates. Therefore, a general rise
              in interest rates can result in the decline in the bond’s price.
              Credit risk is the risk that an issuer will default on payments of
              interest and/or principal. This risk is heightened in lower rated
              bonds. If sold prior to maturity, fixed income securities are
              subject to market risk. All fixed income investments may be worth
              less than their original cost upon redemption or maturity.
            </p>
            <p>
              Remi is a solution for personalizing separately managed account portfolios, powered by technology, research, and human insights. Remi's portfolio construction engine, backed by our fundamental research team, simplifies transitions and tax management. Remi is a service of Allspring Funds Management, LLC.
            </p>
            <p>
              All investing involves risks, including the possible loss of principal.
            </p>
            <p>  
              Allspring Global Investments(Allspring) is the trade name for the asset management companies of Allspring Global Investments Holdings, LLC (Allspring Holdings), a holding company indirectly owned by certain private funds of GTCR LLC and Reverence Capital Partners, L.P. Unless otherwise stated, Allspring is the source of all data (which is current or as of the date stated); content is provided for informational purposes only with no representation regarding its adequacy, accuracy, or completeness and should not be relied upon; views, opinions, assumptions, or estimates are not necessarily that of Allspring Holdings, Allspring, or their affiliates and are subject to change without notice; and this communication does not contain investment advice, an investment recommendation, or investment research, as defined under local regulation of the respective jurisdiction.
            </p>
            <p>  
              This material is for general informational and educational purposes only and is NOT intended to provide investment advice or a recommendation of any kind—including a recommendation for any specific investment, strategy, or plan.
            </p>
          </>
        ),
      },
    ],
    isReportPage: false,
  };

  const equitiesDisclosureArgs = {
    className: "disclosures--proposal",
    bodyContent: [
      {
        heading: marketingCommunication,
        content: (
          <ul>
            <li>Not Insured by the FDIC or Any Federal Government Agency</li>
            <li>
              Not a Deposit or Other Obligation of, or Guaranteed by, the Bank
              or Any Bank Affiliate
            </li>
            <li>
              Subject to Investments Risks, Including Possible Loss of the
              Principal Amount Invested
            </li>
            <li>For Investment Professional Use Only</li>
          </ul>
        ),
      },
      {
        heading: "",
        content: (
          <>
            <p>
              Remi is a solution for personalizing separately managed account portfolios, powered by technology, research, and human insights. Remi's portfolio construction engine, backed by our fundamental research team, simplifies transitions and tax management. Remi is a service of Allspring Funds Management, LLC.
            </p>
            <p>
              All investing involves risks, including the possible loss of principal.
            </p>
            <p>  
              Allspring Global Investments(Allspring) is the trade name for the asset management companies of Allspring Global Investments Holdings, LLC (Allspring Holdings), a holding company indirectly owned by certain private funds of GTCR LLC and Reverence Capital Partners, L.P. Unless otherwise stated, Allspring is the source of all data (which is current or as of the date stated); content is provided for informational purposes only with no representation regarding its adequacy, accuracy, or completeness and should not be relied upon; views, opinions, assumptions, or estimates are not necessarily that of Allspring Holdings, Allspring, or their affiliates and are subject to change without notice; and this communication does not contain investment advice, an investment recommendation, or investment research, as defined under local regulation of the respective jurisdiction.
            </p>
            <p>  
              This material is for general informational and educational purposes only and is NOT intended to provide investment advice or a recommendation of any kind—including a recommendation for any specific investment, strategy, or plan.
            </p>
          </>
        ),
      },
    ],
    isReportPage: false,
  };

  return assetClass === "Equity" ? (
    <Disclosures {...equitiesDisclosureArgs} />
  ) : (
    <Disclosures {...fixedIncomeDisclosureArgs} />
  );
};

export default IntakeFormDisclosure;
